<template>
  <div class="header-global" style="position: relative;">
    <nav class="navbar-main bg-gradient-bowhead fixed-top" expand contentId="customNav">
      <div class="col-lg-10 container">
        <div class="align-items-center">
          <div class="row">
            <router-link to="/" class="d-none d-md-block col-sm">
              <img src="../assets/logo_white.png" height="60">
            </router-link>
            <router-link to="/" class="d-md-none col-sm">
              <div class="container">
              <div class="col"></div>
              <div class="col-8">
              <img src="../assets/logo_white.png" height="60" class="float-right d-block">
              </div>
              <div class="col"></div>
              </div>
            </router-link>
            <div class="col-sm">
              <br class="d-lg-none">
              <base-input alternative placeholder="Enter Address, Contract, Token, TxHash, or Block Number" addon-right-icon="fa fa-search" rounded v-model="search" @keyup.enter="checkSearchBar">
              </base-input>
            </div>
          </div>
        </div>
      </div>
    </nav>
	</div>
</template>

<script>
import BaseNav from '@/components/BaseNav'
import CloseButton from '@/components/CloseButton'

export default {
  components: {
    BaseNav,
    CloseButton
  },
  data: function () {
    return {
      errors: [],
      search: ''
    }
  },
  methods: {
    checkSearchBar (e) {
      this.errors = []

      if (this.validTransaction(this.search)) {
        this.$router.push('/tx/' + this.search)
      } else if (this.validAddress(this.search)) {
        this.$router.push('/address/' + this.search)
      } else if (this.search === '') {
        this.$router.push('/')
      } else if (this.validBlock(this.search)) {
        this.$router.push('/block/' + this.search)
      } else {
        this.$router.push('/')
      }

      e.preventDefault()
    },
    validTransaction (input) {
      var txRE = /^0x([A-Fa-f0-9]{64})$/
      return txRE.test(input)
    },
    validAddress (input) {
      var addressRE = /^0x([A-Fa-f0-9]{40})$/
      return addressRE.test(input)
    },
    validBlock (input) {
      var numberRE = /^[0-9]*$/
      return numberRE.test(input)
    }
  }
}
</script>

<style>
	.bg-gradient-bowhead {
		background-image: linear-gradient(87deg, #31d6d6 0, #2DBCDC 100%) !important;
	}
</style>
